export const viewComponent = [
  { label: '输入框', value: 'text' },
  { label: '密码框', value: 'password' },
  { label: '文本域', value: 'textarea' },
  { label: '数字输入框', value: 'inputNumber' },
  { label: '标签输入框', value: 'inputTag' },
  { label: '开关', value: 'switch' },
  { label: '滑块', value: 'slider' },
  { label: '下拉框', value: 'select' },
  { label: '单选框', value: 'radio' },
  { label: '复选框', value: 'checkbox' },
  { label: '日期选择器', value: 'date' },
  { label: '时间选择器', value: 'time' },
  { label: '上传组件', value: 'upload' },
  { label: 'wangEditor富文本', value: 'wangEditor' },
  { label: '评分器', value: 'rate' }
  // { label: '提及', value: 'mention' },
  // { label: '树形下拉框', value: 'treeSelect' },
  // { label: '级联选择器', value: 'cascader' },
  // { label: '数据穿梭框', value: 'transfer' },
  // { label: '用户选择器', value: 'selectUser' },
  // { label: '用户信息', value: 'userInfo' },
  // { label: '省市区联动', value: 'cityLinkage' },
  // { label: '子表单', value: 'formGroup' },
  // { label: '资源选择器', value: 'selectResource' },
  // { label: '富文本控件', value: 'editor' },
  // { label: '代码编辑器', value: 'codeEditor' }
]
